import { Card } from "@mui/material";
import { grey } from "@mui/material/colors";
const ProfileSectionContentCard = ({
  children,

  sx,
}) => {
  return (
    <>
      <Card
        variant="outlined"
        sx={{
          border: `1px solid ${grey[200]}`,
          // border: "1px solid rgba(225, 228, 232, 0.41)",
          // boxShadow: "none",
          // boxShadow:
          //   "rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.1) 0px 4px 6px -4px",
          ...sx,
        }}
      >
        {children}
      </Card>
    </>
  );
};

export default ProfileSectionContentCard;
